import { SearchTerm } from './SearchTerm';

const ReaderSearch: SearchTerm[] = [
    {
        heading: "Name",
        accessor: "name",
        searchOnName: "devName",
        translationKey: "name"
    },
    {
        heading: "Fixed Address",
        accessor: "fixedAddress",
        searchOnName: "devFixedAddr",
        translationKey: "fixedAddress"
    },
    {
        heading: "IP Address",
        accessor: "ipAddress",
        searchOnName: "devIpAddress",
        translationKey: "ipAddress"
    },
    {
        heading: "Type",
        accessor: "type",
        searchOnName: "unitType.trnName",
        translationKey: "type"
    },
    {
        heading: "Site",
        accessor: "site",
        searchOnName: "site.siteName",
        translationKey: "site"
    },
    {
        heading: "Controller",
        accessor: "controller",
        searchOnName: "controller.devName",
        translationKey: "controller"
    },
    {
        heading: "Door",
        accessor: "door",
        searchOnName: "location.locName",
        translationKey: "door"
    },
    {
        heading: "Preset",
        accessor: "preset",
        searchOnName: "profile.trnName",
        translationKey: "preset"
    },
];

export default ReaderSearch;
